import { useTranslation } from 'react-i18next';

import type { PortalBillingPeriod } from '@/modules/portal/types/portalPlans';
import { cn } from '@/shared/lib/cn';

type BillingPeriodToggleProps = {
  value: PortalBillingPeriod;
  periods: PortalBillingPeriod[];
  onChange: (period: PortalBillingPeriod) => void;
  className?: string;
};

export function BillingPeriodToggle({
  value,
  periods,
  onChange,
  className,
}: BillingPeriodToggleProps) {
  const { t } = useTranslation();

  if (periods.length <= 1) {
    return null;
  }

  return (
    <div
      role="group"
      aria-label={t('portal.plans.billingToggle.label')}
      className={cn('inline-flex rounded-xl border border-border/60 bg-muted/40 p-1', className)}
    >
      {periods.map((period) => {
        const selected = period === value;
        return (
          <button
            key={period}
            type="button"
            aria-pressed={selected}
            onClick={() => onChange(period)}
            className={cn(
              'rounded-lg px-4 py-2 text-sm font-medium transition-colors',
              selected
                ? 'bg-background text-foreground shadow-sm'
                : 'text-muted-foreground hover:text-foreground',
            )}
          >
            {t(`portal.plans.billingToggle.${period}`)}
          </button>
        );
      })}
    </div>
  );
}
